import { Component, OnInit, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';

import { ConfigService } from '@gsrs-core/config';
import { AuthService } from '@gsrs-core/auth/auth.service';
import { LoadingService } from '@gsrs-core/loading';
import { ConfirmDialogComponent } from '../../../confirm-dialog/confirm-dialog.component';
import { ImpuritiesService } from '../../service/impurities.service';
import { GeneralService } from '../../../service/general.service';
import { Impurities, ImpuritiesSubstance, ImpuritiesTesting, ImpuritiesDetails, IdentityCriteria, SubRelationship } from '../../model/impurities.model';


@Component({
  selector: 'app-impurities-substance-form',
  templateUrl: './impurities-substance-form.component.html',
  styleUrls: ['./impurities-substance-form.component.scss']
})
export class ImpuritiesSubstanceFormComponent implements OnInit {

  @Input() impuritiesSubstance: ImpuritiesSubstance;
  @Input() impuritiesSubstanceIndex: number;

  isLoading = true;
  errorMessage: string;
  searchValue: string;
  subscriptions: Array<Subscription> = [];
  existingImpurities: Array<SubRelationship> = [];

  //  subRelationship: Array<SubRelationship> = [];
  substanceName: string;
  substanceNameHintMessage = '';

  private privateShowAdvancedSettings = false;
  configSettingsDisplay = {};

  constructor(
    private impuritiesService: ImpuritiesService,
    private configService: ConfigService,
    private generalService: GeneralService,
    private loadingService: LoadingService,
    private authService: AuthService,
    private dialog: MatDialog) { }

  ngOnInit() {
  }

  @Input()
  set showAdvancedSettings(showAdvancedSettings: boolean) {
    this.privateShowAdvancedSettings = showAdvancedSettings;

    // Get Config Settins from config file
    this.getConfigSettings();
  }

  get showAdvancedSettings(): boolean {
    return this.privateShowAdvancedSettings;
  }
  
  getConfigSettings(): void {
    // Get Impurities Config Settings from config.json file to show and hide fields in the form
    let configImpuritiesForm: any;
    configImpuritiesForm = this.configService.configData && this.configService.configData.impuritiesForm || null;
    
    // Get 'substance' json values from config
    const confSettings = configImpuritiesForm.settingsDisplay.substance;

    Object.keys(confSettings).forEach(key => {
      if (confSettings[key] != null) {
        if (confSettings[key] === 'simple') {
          this.configSettingsDisplay[key] = true;
        } else if (confSettings[key] === 'advanced') {
          if (this.privateShowAdvancedSettings === true) {
            this.configSettingsDisplay[key] = true;
          } else {
            this.configSettingsDisplay[key] = false;
          }
        } else if (confSettings[key] === 'removed') {
          this.configSettingsDisplay[key] = false;
        }
      } else {
        // if either value (simple,advanced,removed) missing in config, show field on the form
        this.configSettingsDisplay[key] = true;
      }
    });
  }

  relatedSubstanceUpdated(substance: any): void {
    if (substance != null) {
      this.impuritiesSubstance.substanceUuid = substance.uuid;
      this.impuritiesSubstance.approvalID = substance.approvalID;
    }
  }

  getExistingImpuritiesFromSubstance(event: Event) {
    event.stopPropagation();

    this.isLoading = true;
    this.loadingService.setLoading(true);
    this.errorMessage = 'Getting Existing Impurities...';

    const substanceUuid = this.impuritiesSubstance.substanceUuid;
    if (substanceUuid) {
      const getRelImpuritySubscribe = this.impuritiesService.getRelationshipImpurity(substanceUuid).subscribe(response => {

        if (response) {
          const relImpurities = response;
          if (Object.keys(relImpurities).length > 0) {
            // Remove Duplicate Impurites Substance UUID
            this.existingImpurities = relImpurities.filter((v, i) => relImpurities.findIndex
              (item => item.relationshipUuid === v.relationshipUuid) === i);
            this.loadExistingImpurities();
          } else {
            this.errorMessage = 'No Impurities found';
          }
        }
      });
      this.subscriptions.push(getRelImpuritySubscribe);
    } else {
      this.errorMessage = 'Please select a Substance Name';
    }

    this.loadingService.setLoading(false);
    this.isLoading = false;
  }

  loadExistingImpurities() {
    this.errorMessage = 'Found ' + this.existingImpurities.length + ' Existing Impurities';
    // Add New Test
    this.impuritiesService.addNewTest(this.impuritiesSubstanceIndex);
    this.existingImpurities.forEach((elementRel) => {

      const newImpuritiesDetails: ImpuritiesDetails = { identityCriteriaList: [] };
      newImpuritiesDetails.relatedSubstanceUuid = elementRel.relationshipUuid;
      newImpuritiesDetails.relatedSubstanceUnii = elementRel.relationshipUnii;
      // Creating a New Impurities Detail for Test 0
      this.impuritiesService.addNewImpuritiesDetails(this.impuritiesSubstanceIndex, 0, newImpuritiesDetails);
    });
  }

  createNewImpurities(relationshipUuid: string) {
    const newImpuritiesDetails: ImpuritiesDetails = { identityCriteriaList: [] };
    newImpuritiesDetails.relatedSubstanceUuid = relationshipUuid;
  }

  addNewImpuritiesSubstance() {
    this.impuritiesService.addNewImpuritiesSubstance();
  }

  getSubstancePreferredName(substanceUuid: string): void {
    const getSubDetailsSubscribe = this.generalService.getSubstanceBySubstanceUuid(substanceUuid).subscribe(substance => {
      if (substance) {
        this.searchValue = substance._name;
      }
    });
    this.subscriptions.push(getSubDetailsSubscribe);
  }

  addNewTest(event: Event) {
    event.stopPropagation();

    this.impuritiesService.addNewTest(this.impuritiesSubstanceIndex);
  }

  //new 3.1
  addNewResidualSolventsTest(event: Event) {
    event.stopPropagation();

    this.impuritiesService.addNewResidualSolventsTest(this.impuritiesSubstanceIndex);
  }

  //new 3.1
  addNewInorganicTest(event: Event) {
    event.stopPropagation();

    this.impuritiesService.addNewInorganicTest(this.impuritiesSubstanceIndex);
  }


  /* remove in 3.1
  addNewImpuritiesResidualSolvents(event: Event) {
    event.stopPropagation();

    this.impuritiesService.addNewImpuritiesResidualSolvents(this.impuritiesSubstanceIndex);
  }
  */

  /*  remove in 3.1
  addNewImpuritiesInorganic(event: Event) {
    event.stopPropagation();

    this.impuritiesService.addNewImpuritiesInorganic(this.impuritiesSubstanceIndex);
  }
  */

  confirmDeleteImpuritiesSubstance() {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: { message: 'Are you sure you want to delele Substance ' + (this.impuritiesSubstanceIndex + 1) + '?' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result === true) {
        this.deleteImpuritiesSubstance();
      }
    });
  }

  deleteImpuritiesSubstance() {
    this.impuritiesService.deleteImpuritiesSubstance(this.impuritiesSubstanceIndex);
  }

}